/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { connect } from 'react-redux';

import api from 'api';

import uiStateActions from 'redux/actions/uiState';
import navigationActions from 'redux/actions/navigation';
import groupActions from 'redux/actions/group';

import GroupSetupPresenter from './GroupSetup.presenter';
import routeNames from 'lib/routeNames';

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    goBack: () => {
      dispatch(navigationActions.goBackTo(routeNames.groupSettings()));
    },
    createGroup: (group) => {
      return dispatch(groupActions.updated(group));
    },
    showApiError: (apiError) => {
      dispatch(uiStateActions.showApiError(apiError));
    }
  };
}

class GroupSetup extends React.Component {

  constructor(props) {
    super(props);

    this.createGroup = this.createGroup.bind(this);

    this.state = {
      groupCreatedSuccessful: false,
    };
  }

  createGroup(data) {
    api.groupApi.create(data)
    .then(() => {
      this.setState({
        groupCreatedSuccessful: true,
      });
    })
    .catch(this.props.showApiError);
  }

  render() {
    return (
      <GroupSetupPresenter
        createGroup={this.createGroup}
        groupCreatedSuccessful={this.state.groupCreatedSuccessful}
        resetGroupCreate={() => { this.setState({ groupCreatedSuccessful: false }); }}
      />
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupSetup);